import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import NavBar from "./components/Navigation/Navigation";
import HomeTwo from "./components/pages/HomeTwo";
import AboutTwo from "./components/pages/AboutTwo";
import Organisations from "./components/pages/Organisations";
import ScheduleFour from "./components/pages/ScheduleFour";
import NotFound from "./components/pages/NotFound";
import Faq from "./components/pages/Faq";
import BlogOne from "./components/pages/BlogOne";
import BlogDetails from "./components/pages/BlogDetails";
import Organisationitem from "./components/pages/Organisationitem";
import { useTranslation } from 'react-i18next';
import BlogSpecCategory from "./components/pages/BlogSpecCategory";
import LanguageSwitch from "./LanguageSwitch/LanguageSwitch";



import LocalizedStrings from 'react-localization';
import localeFile from './local/content';

import {connect} from 'react-redux';
import Contact from "./components/pages/Contact";
import AboutTwo2 from "./components/pages/AboutTwo2";
// Conditionally render Navigation
const renderNavigation = () => {
    // if (!(window.location.pathname === '/login' || window.location.pathname === '/signup' || window.location.pathname === '/coming-soon' || window.location.pathname === '/error-404')){
    //     return <Navigation />;
    // }
}

const AppRouter = () => {
    const strings = new LocalizedStrings(localeFile);

 
  
    return (
      
         
          

        <Router>
         
    <NavBar/>
            <Switch>
                <Route path="/" exact component={HomeTwo} />
                <Route path="/home" exact component={HomeTwo} />
               
                <Route path="/about-2" exact component={AboutTwo} />
                <Route path="/about-22" exact component={AboutTwo2} />

                <Route path="/Organisations" exact component={Organisations} />
         
                <Route path="/Ressources" exact component={ScheduleFour} />
        
                <Route path="/faq" exact component={Faq} />
              
                <Route path="/blog-1" exact component={BlogOne} />
                <Route path="/blog/:id" exact component={BlogSpecCategory} />
                <Route path="/contact" exact component={Contact} />

             
                <Route path="/single-blog/:id" exact component={BlogDetails} />
                <Route path="/Organisation/:id" exact component={Organisationitem} />
                <Route path="/error-404" exact component={NotFound} />
                <Route component={NotFound} />
            </Switch>  
        </Router>
        
    );
};

export default AppRouter;